import Checkbox from '@vromo/ui/components/Checkbox';
import theme from '@vromo/ui/components/theme';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FleetOption, RestaurantType } from '../../interfaces';
import styles from './chooseActivePartnerships.style';

interface Props {
    restaurants: RestaurantType[];
    existingProviders: string[];
    setExistingProviders: (existingProviders: string[]) => void;
}

const ChooseActivePartnerships = ({
    restaurants,
    existingProviders,
    setExistingProviders
}: Props) => {
    const { t } = useTranslation();

    const fleetResults: string[] = useMemo(() => {
        const fleetOptionsForAll: string[] = [];
        restaurants.forEach((restaurant: RestaurantType) => {
            restaurant?.fleetOptions?.forEach(
                (option: FleetOption) =>
                    !fleetOptionsForAll.includes(option.name) &&
                    fleetOptionsForAll.push(option.name)
            );
        });
        return fleetOptionsForAll;
    }, [restaurants]);

    return (
        <div>
            <p style={styles.activePartnersTitle}>{t('findFleets.existingAgreements')}</p>
            <p style={styles.activePartnersSubtitle}>{t('findFleets.letUsKnow')}</p>
            {fleetResults.map((name, index) => {
                const checked = existingProviders.includes(name);
                const onChange = () =>
                    setExistingProviders(
                        checked
                            ? existingProviders.filter((n) => name !== n)
                            : [...existingProviders, name]
                    );
                return (
                    <Checkbox
                        key={`existing-provider-${index}`}
                        label={name}
                        labelStyle={styles.checkboxLabel}
                        checkedColor={theme.tertiary}
                        {...{ onChange, checked }}
                    />
                );
            })}
        </div>
    );
};

export default ChooseActivePartnerships;
